<template>
  <div id="add-new-order-modal">
    <v-layout row justify-center>
      <v-dialog v-model="edit1Modal" persistent max-width="340px">
        <v-card>
          <form action="" @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex xs11 sm11 md11><span class="headline">{{ $t('common.update') }}</span></v-flex>
              <v-flex xs1 sm1 md1>
                <v-btn flat @click="closeEdit1Modal" class="close"><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert :value="seccessAlert" type="success">
                {{ $t('editPriceForCountry.priceUpdatedSuccessfully') }}
              </v-alert>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm3 md3>
                    <v-text-field
                      :label="$t('editPriceForCountry.pricePerWeightTurkeyLabel') + '*'"
                      v-model="edit1Data.item_weight_price_turkey"
                      :error-messages="errors.collect('Price per weight for Turkey')"
                      v-validate="'required'"
                      data-vv-name="Price per weight for Turkey"
                      autofocus
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-20"
                outline
                color="success"
                >{{ $t('common.save') }}</v-btn
              >
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ['seccessAlert', 'edit1Modal', 'closeEdit1Modal', 'edit1Data', 'editPriceForTurkey'],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editPriceForTurkey()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editPriceForTurkey.vue